import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Groups from './Groups';
import VehiclesTable from './VehiclesTable';

import './SelectableVehicles.css';

@inject('filterStore', 'translationsStore', 'commonStore')
@observer
export default class SelectableVehicles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      selectedGroup: 'all'
    };
  }

  componentWillUnmount() {
    this.props.filterStore.reset();
  }

  onGroupChange = () => {
    this.resetTableView();
  };

  onSelectedRowsChange = selectedRows => {
    this.setState({ selectedRows });
  };

  resetTableView = () => {
    this.setState({ selectedRows: [] });
  };

  apply = () => {
    this.props.filterStore.apply();
  };

  render() {
    const { vehicles, vehiclesFiltered, filterStore } = this.props;
    const { selectedRows, selectedGroup } = this.state;

    return (
      <div className="SelectableVehicles">
        <Groups
          vehicles={vehicles}
          onSelect={({ selected, group }) => {
            this.setState({ selectedGroup: selected, groupData: null });
            filterStore.remove('groupFilter');
            if (selected === 'tobeconnected') {
              filterStore.add('groupFilter.group_tobeconnected', subscription => subscription.managementStatus === 'tobeconnected');
            }
            if (selected === 'connected') {
              filterStore.add('groupFilter.group_connected', subscription => subscription.managementStatus === 'connected');
            }
            if (selected === 'tobedisconnected') {
              filterStore.add('groupFilter.group_tobedisconnected', subscription => subscription.managementStatus === 'tobedisconnected');
            }
            if (selected === 'disconnected') {
              filterStore.add('groupFilter.group_disconnected', subscription => subscription.managementStatus === 'disconnected');
            }
            filterStore.apply();
          }}
          selected={selectedGroup}
          onGroupChange={this.onGroupChange}
        />
        <div style={{ display: 'flex', flexDirection: 'column' }} className="content">
          <VehiclesTable vehicles={vehiclesFiltered} selectedRows={selectedRows} onSelectedRowsChange={this.onSelectedRowsChange} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/SelectableVehicles/SelectableVehicles.js